export const Menu = [
  {
    id: "dashboard",
    mainMenu: "Dashboard",
    iconClass: "bi bi-speedometer2", // Dashboard-style icon
    color: "#4CAF50", // Green
    navigationPath: "/Dashboard",
    allowrole: ["Admin"]
  },
  {
    id: "regulations",
    mainMenu: "Regulations",
    iconClass: "bi bi-journal-text", // Represents legal/regulation docs
    color: "#2196F3", // Blue
    navigationPath: "/Regulations",
    allowrole: ["Admin"],
  },
  {
    id: "databaseHealth",
    mainMenu: "Database Health",
    iconClass: "bi bi-activity", // Health/monitoring
    color: "#FF9800", // Orange
    navigationPath: "/DatabaseHealth",
    allowrole: ["Admin"],
  },
  {
    id: "products",
    mainMenu: "Products",
    iconClass: "bi bi-box-seam", // Product/package
    color: "#9C27B0", // Purple
    navigationPath: "/Products",
    allowrole: ["Admin"],
  },
  {
    id: "regulationproducts",
    mainMenu: "Regulation Products",
    iconClass: "bi bi-clipboard-check", // Checklist/compliance
    color: "#3F51B5", // Indigo
    navigationPath: "/RegulationProducts",
    allowrole: ["Admin"],
  },
  {
    id: "errorproducts",
    mainMenu: "Error Products",
    iconClass: "bi bi-exclamation-triangle", // Warning/error
    color: "#F44336", // Red
    navigationPath: "/ErrorProducts",
    allowrole: ["Admin"],
  },
  {
    id: "chemindex",
    mainMenu: "ChemIndex",
    iconClass: "bi bi-folder2-open", // Folder for data category
    color: "#795548", // Brown
    allowrole: ["Admin"],
    children: [
      {
        id: "productImport",
        submenuItem: "Product Import",
        iconClass: "bi bi-upload", // Upload/import
        color: "#8BC34A", // Light Green
        navigationPath: "/ProductImport",
      },
      {
        id: "syncData",
        submenuItem: "Sync Data",
        iconClass: "bi bi-arrow-repeat", // Sync arrows
        color: "#00BCD4", // Cyan
        navigationPath: "/SyncData",
      },
      {
        id: "linkuprequest",
        submenuItem: "Linkup Request",
        iconClass: "bi bi-link-45deg", // Link icon
        color: "#FF5722", // Deep Orange
        navigationPath: "/LinkupRequest",
      },
      {
        id: "regulationRequest",
        submenuItem: "Regulation Request",
        iconClass: "bi bi-file-earmark-text", // Document request
        color: "#9E9E9E", // Gray
        navigationPath: "/RegulationRequest",
      },
      {
        id: "imageGenerationRequest",
        submenuItem: "Image Management",
        iconClass: "bi bi-image", // Document request
        color: "#3F51B5", // Gray
        navigationPath: "/ImageGenerationRequest",
      },
    ]
  },
  {
    id: "configuration",
    mainMenu: "Configuration",
    iconClass: "bi bi-gear", // Settings
    color: "#607D8B", // Blue Gray
    allowrole: ["Admin"],
    children: [
      {
        id: "propertyData",
        submenuItem: "Property Data",
        iconClass: "bi bi-card-list", // Data list
        color: "#4CAF50", // Green
        navigationPath: "/Configuration/PropertyData",
        allowrole: ["Admin"],
      },
      // {
      //   id: "chemPatternData",
      //   submenuItem: "ChemPattern Data",
      //   iconClass: "bi bi-bezier",
      //   color: "#607D8B",
      //   navigationPath: "/Configuration/ChemPatternData",
      //   allowrole: ["Admin"],
      // },
      {
        id: "synonymData",
        submenuItem: "Synonym Data",
        iconClass: "bi bi-quote", // Quotes for synonyms
        color: "#FF9800", // Orange
        navigationPath: "/Configuration/SynonymData",
        allowrole: ["Admin"],
      },
      {
        id: "safetyData",
        submenuItem: "Safety Data",
        iconClass: "bi bi-shield-check", // Safety/security
        color: "#F44336", // Red
        navigationPath: "/Configuration/SafetyData",
        allowrole: ["Admin"],
      },
      {
        id: "precautionaryData",
        submenuItem: "Precautionary Data",
        iconClass: "bi bi-exclamation-circle", // Safety/security
        color: "#FF9800", // Red
        navigationPath: "/Configuration/PrecautionaryData",
        allowrole: ["Admin"],
      },
      {
        id: "pictogramAsset",
        submenuItem: "Pictogram Asset",
        iconClass: "bi bi-tropical-storm",
        color: "#A855F7", // Red
        navigationPath: "/Configuration/PictogramAsset",
        allowrole: ["Admin"],
      },
      {
        id: "hazardStatement",
        submenuItem: "Hazard Statement",
        iconClass: "bi bi-exclamation-triangle",
        color: "#06B6D4", // Red
        navigationPath: "/Configuration/HazardStatement",
        allowrole: ["Admin"],
      },
      {
        id: "Scheduler",
        submenuItem: "Scheduler ",
        iconClass: "bi bi-alarm",
        color: "#607D8B",
        navigationPath: "/Configuration/SchedulerDetails",
        allowrole: ["Admin"],
      },
      {
        id: "App Management",
        submenuItem: "App Management",
        iconClass: "bi bi-gear",
        color: "#00699dff",
        navigationPath: "/Configuration/AppManagement",
        allowrole: ["Admin"],
      },
      {
        id: "Applications",
        submenuItem: "Applications",
        iconClass: "bi bi-grid-3x3-gap",
        color: "#0284C7",
        navigationPath: "/Configuration/Applications",
        allowrole: ["Admin"],
      },
    ],
  },
];